export default {
  FETCH_PROJECTS_REQUEST: 'FETCH_RELATED_PROJECTS_REQUEST',
  FETCH_PROJECTS_SUCCESS: 'FETCH_RELATED_PROJECTS_SUCCESS',
  FETCH_PROJECTS_FAILURE: 'FETCH_RELATED_PROJECTS_FAILURE',
  RESET_PROJECTS: 'RESET_RELATED_PROJECTS',
  SAVE_PROJECTS_REQUEST: 'SAVE_RELATED_PROJECTS_REQUEST',
  SAVE_PROJECTS_SUCCESS: 'SAVE_RELATED_PROJECTS_SUCCESS',
  SAVE_PROJECTS_FAILURE: 'SAVE_RELATED_PROJECTS_FAILURE'
}
